import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-13/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "The datasheet of an  electrodynamic geophone is given below. Calculate the value of the load<br>resistance that allows to get the value of the nominal sensitivity.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/13/task/task-3.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
